<template>
    <ReserveConfirm />
</template>

<script>
import ReserveConfirm from "@/components/ReserveConfirm.vue";


export default {
    name: 'ReserveConfirmView',
    components: {
        ReserveConfirm
    }
}
</script>